const allServicesSliderSections = document.querySelectorAll(
  "section.all-services"
);
allServicesSliderSections.forEach((section) => {
  let current = 0;
  const slider = section.querySelector(".slider");
  const container = slider.parentNode;
  let slides = section.querySelectorAll(".slider li");
  let navs = section.querySelectorAll(".nav li");
  navs.forEach((nav, index) => {
    nav.addEventListener("click", () => {
      current = index;
      const left = slides[index].offsetLeft;
      container.scrollTo({ left, behavior: "smooth" });
    });
  });
});
